import React, {PropTypes} from 'react';
import ReactDOM from 'react-dom';

export default class BlueCheckbox extends React.Component {
  constructor() {
    super()
    this.state = {checked: false}
  }

  handleChange(e) {
    this.setState(oldState => ({checked: !oldState.checked}))
    this.props.handleChange(e)
  }

  render() {
    const {props} = this
    const wrapperClass = this.state.checked ? 'filter active' : 'filter'
    return (
      <div className={wrapperClass} onClick={(e) => {this.handleChange(e)}}>
        {props.name}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/browser/components/smart/BlueCheckbox.react.js